import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import thunkMiddleware from "redux-thunk";
import { pianoReducer as piano, refreshListener } from "react-piano-manager";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

window.broadcast_channel = "piano";
refreshListener();

const configureStore = (initialState = {}) =>
  createStore(
    combineReducers({
      piano
    }),
    initialState,
    composeEnhancers(applyMiddleware(thunkMiddleware))
  );

export default configureStore;
